import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class PressionDeclencheur extends IdCodeLibelle {}
